import { SelectValueStyle } from 'elements/minute/sidebar/sidebarComponents/atomic/SelectValue/SelectValueStyle';
import { EColors2, EFonts } from 'libs/styles/styling';

export const GuideInputSelectStyle = (params: { hideIcon: boolean }) => ({
    ...SelectValueStyle,
    input: (provided) => ({
        ...provided,
        fontFamily: EFonts.Regular
    }),
    placeholder: (provided) => ({
        ...provided,
        fontSize: '15px',
        fontFamily: EFonts.Regular
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        fontSize: '15px',
        height: '70px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: EColors2.DARK,
        fontFamily: EFonts.Regular,
        padding: '15px',
        textAlign: 'left',
        lineHeight: '25px'
    }),
    loadingMessage: (provided) => ({
        ...provided,
        fontSize: '15px',
        color: EColors2.DARK,
        fontFamily: EFonts.Regular
    }),
    control: (provided) => ({
        ...provided,
        border: '1px solid #e3e3e3',
        boxShadow: 'none !important',
        borderRadius: '15px',
        height: '44px',
        backgroundColor: '#fafcfe',
        paddingLeft: params.hideIcon ? '0px' : '40px',
        '&:hover': {
            border: '1px solid #E7E7E7'
        },
        '&:focus': {
            border: '1px solid #E7E7E7',
            boxShadow: 'none',
            outline: 'none'
        }
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 100000,
        borderRadius: '15px',
        marginTop: '5px',
        boxShadow: 'none',
        border: '1px solid #e3e3e3'
    }),
    menuList: (provided) => ({
        ...provided,
        borderRadius: '15px',
        paddingTop: '0',
        paddingBottom: '0',
        maxHeight: '200px'
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#E7E7E7' : '#fff',
        color: EColors2.DARK,
        fontSize: '15px',
        height: '44px',
        display: 'flex',
        alignItems: 'center',
        fontFamily: EFonts.Regular,
        '&:hover': {
            backgroundColor: '#E7E7E7'
        }
    }),
    valueContainer: (provided) => ({
        ...provided,
        fontSize: '15px',
        padding: '5px 10px'
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#E7E7E7',
        borderRadius: '15px',
        color: EColors2.DARK,
        fontSize: '15px',
        fontFamily: EFonts.Regular,
        padding: '2px 5px'
    })
});
